<template>
    <b-card no-body>
        <descricao-tecnica :propostaId="null"></descricao-tecnica>
    </b-card>
</template>
<script>
import DescricaoTecnica  from "./accordions/descricao_tecnica/index.vue"
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import PropostaService from "@/common/services/proposta/proposta.service";
export default {
    name: "PropostaFormulario",
    components: {
        DescricaoTecnica
    },
    mounted(){
        PropostaService.setEndpoint('Proposta');
         this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Propostas", to: {name: "proposta-todos-lista"}},
            { titulo: "Cadastrar" }
        ]);
    }
}
</script>
<style lang="">
    
</style>